import * as classnames from "classnames";
import * as React from "react";

import { MessageBar, MessageBarType } from "../../../../../shared/components";
import { ApplicantNotificationModel } from "../../../../../shared/models";

/**
 * Prop interface
 */
export type ExternalProps = {
  className?: string;
};

export type InjectedProps = {
  notifications: ApplicantNotificationModel[];
  removeNotification: (key: string) => void;
};

export type EditorMessageBarProps = ExternalProps & InjectedProps;

/**
 * React Component
 */
export const EditorMessageBar: React.FunctionComponent<
  EditorMessageBarProps
> = (props: EditorMessageBarProps) => {
  const { notifications, removeNotification, className } = props;

  const rootStyle = classnames("code-editor-message-bar", {
    [`${className}`]: Boolean(className),
  });

  /**
   * State
   */

  /**
   * Effects
   */

  /**
   * Private Functions
   */

  /**
   * Render
   */
  return (
    <div className={rootStyle}>
      {notifications.map((item) => (
        <MessageBar
          key={item.key}
          type={MessageBarType.Warning}
          dismissSecound={5}
          onClose={() => removeNotification(item.key)}
        >
          {item.element}
        </MessageBar>
      ))}
    </div>
  );
};
